import {observable, action} from "mobx"
import * as api from "../services/api"
import Cookies from "js-cookie";

class UserStore {
    @observable authedUser = null;
    @observable loading = false;
    @observable hubsList = [];
    @observable selectedHub = '';

    @action login = (data) => {
        this.loading = true;
        api.login(data)
            .then(res => {
                Cookies.set('token', res.access_token, { 'expires': 30 })
                this.authedUser = res.access_token
            })
            .catch(e => {
                alert(e)
            })
            .finally(() => this.loading = false)
    };

    @action handleGetHubs = () => {
        this.loading = true;
        let hubsList = [];
        api.getHubs()
            .then(res => {
                if (res.length > 0) {
                    res.forEach((r) => {
                        const hubsObj = {
                            value: r.code,
                            label: r.name,
                            city: r.city
                        };
                        hubsList.push(hubsObj)
                    })
                }
                this.hubsList = hubsList;
            })
            .catch(e => console.log(e))
            .finally(() => this.loading = false)
    };

    @action setSelectedHub = (hub) => {
        this.selectedHub = hub;
        localStorage.setItem('hub_code', hub.value);
        localStorage.setItem('hub_name', hub.label);
    }
}

const store = new UserStore()
export default store


// WEBPACK FOOTER //
// ./src/stores/UserStore.js